// code = 2025 국가코드(2자리), code3 = 2026 국가코드(3자리, 엑셀 기준)
function country(name, code, code3, image) {
  return { name, code, code3, image };
}

const countries = [
  country("South Korea (KR)", "KR", "KOR", "https://flagcdn.com/w40/kr.png"),
  country("Albania (AL)", "AL", "ALB", "https://flagcdn.com/w40/al.png"),
  country("Australia (AU)", "AU", "AUS", "https://flagcdn.com/w40/au.png"),
  country("Azerbaijan (AZ)", "AZ", "AZE", "https://flagcdn.com/w40/az.png"),
  country("Belarus (BY)", "BY", "BLR", "https://flagcdn.com/w40/by.png"),
  country("Belgium (BE)", "BE", "BEL", "https://flagcdn.com/w40/be.png"),
  country("Bhutan (BT)", "BT", "BTN", "https://flagcdn.com/w40/bt.png"),
  country("Bolivia (BO)", "BO", "BOL", "https://flagcdn.com/w40/bo.png"),
  country("Bosnia (BA)", "BA", "BIH", "https://flagcdn.com/w40/ba.png"),
  country("Bulgaria (BG)", "BG", "BGR", "https://flagcdn.com/w40/bg.png"),
  country("Canada (CA)", "CA", "CAN", "https://flagcdn.com/w40/ca.png"),
  country("China (CN)", "CN", "CHN", "https://flagcdn.com/w40/cn.png"),
  country("Chinese Taipei (TW)", "TW", "TPE", "https://flagcdn.com/w40/tw.png"),
  country("Finland (FI)", "FI", "FIN", "https://flagcdn.com/w40/fi.png"),
  country("France (FR)", "FR", "FRA", "https://flagcdn.com/w40/fr.png"),
  country("Germany (DE)", "DE", "DEU", "https://flagcdn.com/w40/de.png"),
  country("Greece (GR)", "GR", "GRC", "https://flagcdn.com/w40/gr.png"),
  country("Hong Kong (HK)", "HK", "HKG", "https://flagcdn.com/w40/hk.png"),
  country("Hungary (HU)", "HU", "HUN", "https://flagcdn.com/w40/hu.png"),
  country("India (IN)", "IN", "IND", "https://flagcdn.com/w40/in.png"),
  country("Indonesia (ID)", "ID", "IDN", "https://flagcdn.com/w40/id.png"),
  country("Iran (IR)", "IR", "IRN", "https://flagcdn.com/w40/ir.png"),
  country("Italy (IT)", "IT", "ITA", "https://flagcdn.com/w40/it.png"),
  country("Jordan (JO)", "JO", "JOR", "https://flagcdn.com/w40/jo.png"),
  country("Kazakhstan (KZ)", "KZ", "KAZ", "https://flagcdn.com/w40/kz.png"),
  country("Kyrgyzstan (KG)", "KG", "KGZ", "https://flagcdn.com/w40/kg.png"),
  country("Lebanon (LB)", "LB", "LBN", "https://flagcdn.com/w40/lb.png"),
  country("Libya (LY)", "LY", "LBY", "https://flagcdn.com/w40/ly.png"),
  country("Moldova (MD)", "MD", "MDA", "https://flagcdn.com/w40/md.png"),
  country("Mongolia (MN)", "MN", "MNG", "https://flagcdn.com/w40/mn.png"),
  country("Montenegro (ME)", "ME", "MNE", "https://flagcdn.com/w40/me.png"),
  country("North Macedonia (MK)", "MK", "MKD", "https://flagcdn.com/w40/mk.png"),
  country("Norway (NO)", "NO", "NOR", "https://flagcdn.com/w40/no.png"),
  country("Pakistan (PK)", "PK", "PAK", "https://flagcdn.com/w40/pk.png"),
  country("Peru (PE)", "PE", "PER", "https://flagcdn.com/w40/pe.png"),
  country("Poland (PL)", "PL", "POL", "https://flagcdn.com/w40/pl.png"),
  country("Romania (RO)", "RO", "ROU", "https://flagcdn.com/w40/ro.png"),
  country("Russia (RU)", "RU", "RUS", "https://flagcdn.com/w40/ru.png"),
  country("Serbia (RS)", "RS", "SRB", "https://flagcdn.com/w40/rs.png"),
  country("Singapore (SG)", "SG", "SGP", "https://flagcdn.com/w40/sg.png"),
  country("Slovakia (SK)", "SK", "SVK", "https://flagcdn.com/w40/sk.png"),
  country("South Africa (ZA)", "ZA", "ZAF", "https://flagcdn.com/w40/za.png"),
  country("Spain (ES)", "ES", "ESP", "https://flagcdn.com/w40/es.png"),
  country("Thailand (TH)", "TH", "THA", "https://flagcdn.com/w40/th.png"),
  country("Turkmenistan (TM)", "TM", "TKM", "https://flagcdn.com/w40/tm.png"),
  country("Türkiye (TR)", "TR", "TUR", "https://flagcdn.com/w40/tr.png"),
  country("United Kingdom (UK)", "UK", "GBR", "https://flagcdn.com/w40/gb.png"),
  country("United States (US)", "US", "USA", "https://flagcdn.com/w40/us.png"),
  country("Uzbekistan (UZ)", "UZ", "UZB", "https://flagcdn.com/w40/uz.png"),
  country("Vietnam (VN)", "VN", "VNM", "https://flagcdn.com/w40/vn.png"),
  country("Malaysia (MY)", "MY", "MYS", "https://flagcdn.com/w40/my.png"),
  country("Yemen (YE)", "YE", "YEM", "https://flagcdn.com/w40/ye.png"),
  country("Northern Cyprus (NC)", "NC", "TRNC", "https://flagcdn.com/w40/nc.png"),
];

// 2자리(2025)·3자리(2026) 국가코드 모두 찾음
export const findCountryFlag = (countryCode) => {
  for (var i in countries) {
    if (countries[i].code === countryCode || countries[i].code3 === countryCode) {
      return countries[i].image;
    }
  }
}
